import Cookies from 'js-cookie';

const TOKEN_NAME = 'token';

export function isTokenValid(token: unknown) {
  return typeof token === 'string';
}

export function setToken(token: string) {
  Cookies.set(TOKEN_NAME, token, {
    expires: 365,
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
  });
}

export function clearToken() {
  Cookies.remove(TOKEN_NAME);
}

export function getToken() {
  return Cookies.get(TOKEN_NAME);
}
